import Avatar from '@material-ui/core/Avatar';
import { getSvgPath } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import styled from 'styled-components';
import ToolTip from 'globalcomponents/ToolTip';

const layout = window?.$environment?.CURRENT_LAYOUT;
const SvgIcon = lazy(() => import(`../../../SvgIcon/${layout}`));
const Link = lazy(() => import(`../../Link`));

const StyledAvatar = styled(Avatar)`
  background: transparent !important;
  color: ${({ theme, primary }) =>
    `${
      primary ? theme.colors?.PRIMARY_CONTRAST : theme.palette?.secondary?.main || theme.colors?.SECONDARY_MAIN || '#888'
    } !important`};
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const Icon = ({
  onClick,
  link,
  src = '',
  variant,
  addFilter,
  tableicon,
  className,
  tooltip = '',
  IconContainer,
  id,
  asLink,
  style,
  text,
  alignItems,
  primary = false,
}) => {
  const isSvg = typeof src === 'string' && (src?.includes('.svg') || src?.includes('data:image'));

  const handleClick = (e) => {
    onClick(e);
  };

  // Disable focus listener so tooltip only shows on hover and doesn't persist after
  // click (MUI Tooltip shows on focus by default; click gives focus so tooltip sticks).
  const tooltipProps = tooltip ? { disableFocusListener: true } : {};

  const getComponent = () => {
    if (link) {
      return (
        <ToolTip title={tooltip} {...tooltipProps}>
          <a href={link}>
            <Avatar alt="icon" src={getSvgPath(src)} variant={variant} />
          </a>
        </ToolTip>
      );
    }
    if (asLink) {
      return (
        <ToolTip title={tooltip} {...tooltipProps}>
          <Link onClick={handleClick}>{text}</Link>
        </ToolTip>
      );
    }
    if (isSvg) {
      return (
        <ToolTip title={tooltip} {...tooltipProps}>
          <StyledAvatar
            variant={variant || 'round'}
            alt="icon"
            primary={primary}
            onClick={handleClick}
          >
            <SvgIcon value={src} className={className} />
          </StyledAvatar>
        </ToolTip>
      );
    }

    return (
      <ToolTip title={tooltip} {...tooltipProps}>
        <Avatar
          alt="icon"
          className={addFilter ? 'addFilter' : ''}
          src={getSvgPath(src) || src || undefined}
          onClick={handleClick}
          variant={variant}
        />
      </ToolTip>
    );
  };
  return (
    <IconContainer
      container
      justify="flex-start"
      alignItems={alignItems || 'center'}
      isSvg={isSvg}
      tableicon={tableicon}
      style={style}
      className={className ? className : 'iconContainer'}
      id={id || ''}
    >
      {getComponent()}
    </IconContainer>
  );
};

Icon.defaultProps = {
  link: '',
  src: '',
  onClick: () => {},
  variant: 'rounded',
};

Icon.propTypes = {
  link: PropTypes.string,
  src: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
};

export default Icon;
